<div class="how-to-redeem-directions-container" *transloco="let t" (swipedown)="close()">
  <app-closable-bottom-sheet-handle (close)="close()"></app-closable-bottom-sheet-handle>
  <div class="title">{{ t('howToRedeem.titleWhy') }}</div>
  <div class="subtitle" [innerHTML]="t('howToRedeem.subtitleWhy')">
  </div>
  <div class="title">{{ t('howToRedeem.titleHowTo') }}</div>
  <div class="step">
    <div class="step-number">1</div>
    @if (data.fullAddress) {
      <div class="step-text" [innerHTML]="t('howToRedeem.steps.addressText',
                    {merchantName: data.merchantName, fullAddress: data.fullAddress})"></div>
    } @else {
      <div class="step-text" [innerHTML]="t('howToRedeem.steps.addressTextNoLocation',
                    {merchantName: data.merchantName})"></div>
    }
  </div>

  <div class="step">
    <div class="step-number">2</div>
    <div class="step-text" [innerHTML]="t('howToRedeem.steps.bankText')"></div>
  </div>

  <div class="step">
    <div class="step-number">3</div>
    <div class="step-text" [innerHTML]="t('howToRedeem.steps.rewardText',
                    {cashBackPercent: data.rewardAmount})"></div>
  </div>

  <button mat-flat-button class="button-medium loyalty"
          (click)="openMapApp(data.latitude, data.longitude)">{{ t('howToRedeem.buttons.getDirections') }}
  </button>
</div>
